<!--
 * @Description: 现金宝充值
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div v-if="xjbFundFileFlag">
        <comp-title-dc back-url-name="moneybox" :back-url-query="{ activeIndex: 1 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/moneyBox' }">
                    {{ $const.getXJBParam("name") }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>充值</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-money-in">
            <el-form
                ref="fundInfo"
                :rules="rules"
                :model="fundInfo"
                label-width="409px"
                v-on:submit.native.prevent
            >
                <el-form-item
                    :label="$const.getXJBParam('sname') + '总资产：'"
                    prop="availableMoney"
                >
                    <div class="available-money-box">
                        <div>
                            <span class="available-money">
                                {{ $util.fmtNum(fundInfo.availableMoney) }}
                            </span>
                            元
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    label="扣款账号："
                    prop="pay"
                    style="position: relative"
                    class="payway-list"
                >
                    <el-select v-model="fundInfo.pay" placeholder="请选择扣款账号"></el-select>
                    <div
                        v-if="dialogBankLists.length > 0"
                        class="hot-area"
                        v-on:click="selectBank"
                    ></div>
                    <span
                        class="add-bank-btn"
                        v-on:click.prevent="
                            $router.push({
                                name: 'addbank'
                            })
                        "
                    >
                        新增银行卡
                    </span>
                </el-form-item>
                <el-form-item label="存入金额：" prop="amount">
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                    />
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="确认金额：">
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <span
                        class="redemp-btn margin-l-10"
                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                    >
                        <span class="like-a">忘记密码？</span>
                    </span>
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="readFileInfoList.length !== 0 || xjbFundFile.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="
                            font-size: 14px;
                            display: flex;
                            align-items: flex-start;
                            padding-left: -10px;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                line-height: 20px;
                                margin-right: 5px;
                            "
                        >
                            <el-checkbox
                                v-model="checkbox"
                                style="margin-right: 5px"
                                v-on:change="handleCheckboxChange"
                            ></el-checkbox>
                            <span style="color: var(--color-text-primary)">我已阅读并同意</span>
                        </div>
                        <ul style="padding: 0; margin: 0; list-style: none">
                            <li
                                v-for="(item, index) in readFileInfoList"
                                :key="'read' + index"
                                style="line-height: 20px"
                            >
                                <a
                                    class="file-content"
                                    target="_blank"
                                    v-on:click="getClick1(index)"
                                >
                                    《{{ item.filename }}》
                                </a>
                            </li>
                            <li
                                v-for="(item, index) in xjbFundFile"
                                :key="'xjb' + index"
                                style="line-height: 20px"
                            >
                                <a
                                    v-if="item.fileid"
                                    class="file-content"
                                    target="_blank"
                                    v-on:click="getClick2(index)"
                                >
                                    《{{ item.title }}》
                                </a>
                                <span v-else class="file-content" v-on:click="argRead(item)">
                                    《{{ item.title }}》
                                </span>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item v-if="tradeRestrictionsShow">
                    <div>
                        <span class="c_E60012">
                            温馨提示：{{ $cache.getCompanyInfoParam("10102035") }}
                        </span>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="margin-top: 20px">
                        <el-button class="back-btn" v-on:click="backFn">返回重选</el-button>
                        <el-button
                            :class="
                                'confirm-btn ' +
                                (disabeldFlag || isOpen ? 'disable-btn' : 'active-btn')
                            "
                            :disabled="disabeldFlag || isOpen"
                            :loading="isOpen"
                            v-on:click="submitInfo()"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <select-bank
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="selectBankShow"
                v-on:select-bank-close="selectBankClose"
                v-on:select-bank-info="selectBankInfo"
            ></select-bank>
            <el-dialog
                title="充值结果"
                :visible.sync="resultDialog"
                class="prop info-tips"
                width="700px"
                :before-close="resultDialogClose"
            >
                <div>
                    <div class="success-res">
                        <div>
                            <img src="../../assets/img/buy_success.png" alt="" />
                        </div>
                        <div class="success-text">
                            {{
                                statusInfo == "0"
                                    ? "充值处理中，请稍后！"
                                    : statusInfo == "1"
                                    ? "充值成功！"
                                    : "充值结果未知，请稍后在交易记录中查询！"
                            }}
                            <span v-if="payStatus != ''">{{ payStatus }}</span>
                        </div>
                    </div>
                    <div class="btn-box">
                        <el-button
                            type="primary"
                            :disabled="!finishStatus"
                            :class="'btn-confirm ' + (!finishStatus ? 'disable-btn' : 'active-btn')"
                            v-on:click="resultDialogClose"
                        >
                            {{ finishStatus ? "确定" : "倒计时" + countTime + "s" }}
                        </el-button>
                    </div>
                </div>
            </el-dialog>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                :show-close="true"
                v-on:close="finishReading"
                v-on:cancel="cancelReading"
            ></pdf-popup>
            <my-dialog
                :title="agrData.title"
                :visible.sync="agrVisible"
                :dialog-close="agrVisibleHide"
                width="800px"
            >
                <div class="protocol-detail" v-html="agrData.content"></div>
                <div class="align-c">
                    <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                        确定
                    </el-button>
                </div>
            </my-dialog>
            <fund-protocol
                ref="protocol"
                v-model="protocol"
                :fund="protocolFund"
                v-on:all-read="smsCheck"
            />
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            :warning-html="warningHtml"
        ></footer-questions>
        <smsValid
            :mobileno="$cache.getUser().mobileno"
            :en-mobileno="$cache.getUser().en_mobileno"
            :dialog-visible="smsVisible"
            sms-type="2"
            show-remote
            v-on:close="smsClose"
            v-on:sms-comfirm="generalBuy(true)"
        />
        <buy-risk-dialog
            :visible.sync="buyRiskdialogVisible"
            :type="dialogType"
            :content="dialogContent"
            :button-text="dialogButtonText"
            v-on:confirm="handleDialogConfirm"
        />
    </div>
</template>
<script>
import selectBank from "@/components/layout/selectBank.vue";
import mixin from "@/assets/js/mixin";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import myDialog from "@/components/layout/myDialog.vue";
import fundProtocol from "@/components/form/fundProtocol";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import smsValid from "@/components/form/smsValid.vue";
import userApi from "@/api/user";
import commonApi from "@/api/common";
import format from "date-fns/format";
import buyRiskDialog from "@/components/fund/buyRiskDialog.vue";

export default {
    name: "MoneyIn",
    components: {
        selectBank,
        PdfPopup,
        myDialog,
        fundProtocol,
        footerQuestions,
        smsValid,
        buyRiskDialog
    },
    mixins: [mixin],
    data() {
        return {
            fund: {},
            fundcode: "",
            xjbFundFile: [],
            xjbFundFileFlag: false,
            readFileInfoList: [], // 披露文件信息
            currentFileInfoList: [], // 当前阅读信批文件
            checkbox: false,
            pdfVisible: false,
            protocol: false,
            protocolFund: {},
            needTime: false,
            agrVisible: false,
            agrData: {},
            pla: "请输入存入金额",
            isOpen: false,
            fundInfo: {
                pay: "",
                amount: "",
                availableMoney: "0",
                pwd: ""
            },
            isPwdCheck: false,
            resultDialog: false,
            selectBankShow: false,
            dialogBankLists: [],
            bankInfo: {},
            limit: { text: "存入金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                pay: [
                    {
                        required: true,
                        message: "请选择支付方式",
                        trigger: "change"
                    }
                ],
                amount: [
                    {
                        validator: this.amountLimit,
                        mes: "投资金额",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            warningHtml: "",
            randomToken: "",
            payStatus: "",
            finishStatus: false, // 是显示确认还是倒计时
            statusInfo: "0", // 交易状态情况  0:处理中 1:成功 2:失败或者处理时间内没结果
            countTime: 5,
            timer: null,
            appsheetserialno: "",
            smsVisible: false,
            tradeRestrictionsShow: false, // 节假日xx宝的提示
            buyRiskdialogVisible: false, // 弹窗显示状态
            dialogType: "", // 弹窗类型（forbid/warn）
            dialogContent: "", // 弹窗文案
            dialogButtonText: "", // 按钮文案
            paramsData: {},
            currentIndex: 0, // 文件下标
            hasReadProductOverview: false // 是否已完整阅读产品概要
        };
    },
    computed: {
        disabeldFlag() {
            if (this.readFileInfoList.length === 0 && this.xjbFundFile.length === 0) {
                return false;
            }
            return !this.checkbox;
        }
    },
    mounted() {
        this.warningHtml = warningHtml.warningHtml12;
        this.isPwdCheck = this.$cache.getPwdCheck("022");
        this.getAssetsInfo();
        this.queryXjbFundInfo();
        this.$cache.getCompanyInfoParam("10102033") &&
            this.isInTimeRange(
                this.$cache.getCompanyInfoParam("10102033"),
                format(new Date(), "YYYYMMDDhhmmss")
            );
    },
    methods: {
        isInTimeRange(timeRange, currentTime) {
            const [start, end] = timeRange.split(",");
            this.tradeRestrictionsShow = currentTime >= start && currentTime <= end;
            return currentTime >= start && currentTime <= end;
        },
        handleCheckboxChange(val) {
            if (val) {
                // 如果已经完整阅读过产品概要，则不再弹出强制阅读
                if (this.hasReadProductOverview) {
                    return;
                }

                const mandatoryFile = this.readFileInfoList.find(
                    (item) => item.filetype.trim() === "7"
                );
                if (mandatoryFile) {
                    // this.checkbox = false;
                    this.currentFileInfoList = [mandatoryFile];
                    this.needTime = true;
                    this.pdfVisible = true;
                }
            }
        },
        // 查询现金宝信息
        async queryXjbFundInfo() {
            const res = await fundApi.cfgFundrealtimeQueryAll();
            this.fundcode = res.data && res.data[0] && res.data[0].fundcode;
            if (!this.fundcode) {
                this.$message({
                    type: "warning",
                    message: "未配置现金宝信息！"
                });
                return false;
            }
            const fundRes = await fundApi.getFundLists({
                fundcode: this.fundcode,
                pagesize: 10,
                pagenum: 1
            });
            if (fundRes.data) {
                this.fund = fundRes.data.list[0];
                this.getFileInfo();
                this.getBuyWay();
            }
        },
        // 购买前查询
        async getBuyWay() {
            this.dialogBankLists = [];
            const res = await fundApi.qryBeforeBuy({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (res.data && res.data.returnList3) {
                res.data.returnList3.forEach((item) => {
                    item.perdaymax = item.netnomaxperday;
                    item.maxlimitsingle = item.netnomaxbuy;
                    if (item.paycenterid != "0001" && item.paycenterid != "1000") {
                        this.dialogBankLists.push(item);
                    }
                });
            }
            this.dialogBankLists = this.dialogBankLists.filter((item) => {
                return (
                    item.authstatus === "1" && // 已鉴权才能购买
                    item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常）
                );
            });
            // 根据配置参数判断是否展示柜台的卡
            this.dialogBankLists = this.dialogBankLists.filter((item) => {
                return this.$util.showCounterCard() || item.banktype != "1";
            });
        },
        // 获取披露文件信息
        async getFileInfo() {
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    filetype: ""
                },
                (res) => {
                    res.forEach((item) => {
                        item.read = false;
                        if (item.filetype.trim() === "7") {
                            // 产品概要
                            this.readFileInfoList.unshift(item);
                        } else {
                            this.readFileInfoList.push(item);
                        }
                    });
                    this.fund.proto = "xjbBuy";
                    this.$util.getSdxProtocol(this.fund, (res) => {
                        this.fund = res;
                        this.protocolFund = JSON.parse(JSON.stringify(res));
                        this.protocolFund.protoArr = [];
                        if (res.protoArr && res.protoArr.length > 0) {
                            res.protoArr.forEach((item) => {
                                item.filename = item.title;
                                if (item.fileid == null || !item.fileid) {
                                    item.fileid = "";
                                }
                                this.xjbFundFile.push(item);
                            });
                        }
                        this.xjbFundFileFlag = true;
                    });
                }
            );
        },
        // 获取链接点击事件
        getClick1(index) {
            this.currentIndex = index;
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "7") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        getClick2(index) {
            this.currentIndex = this.readFileInfoList.length + index;
            this.currentFileInfoList = [this.xjbFundFile[index]];
            this.needTime = false;
            this.pdfVisible = true;
        },
        finishReading() {
            // 如果阅读的是产品概要（filetype === "7"），标记为已完整阅读
            if (this.currentFileInfoList[0] && this.currentFileInfoList[0].filetype === "7") {
                this.hasReadProductOverview = true;
            }
            this.checkbox = true;
            this.pdfVisible = false;
        },
        cancelReading() {
            this.checkbox = false;
            this.pdfVisible = false;
        },
        backFn() {
            this.$router.push({
                name: "moneybox",
                query: { activeIndex: "1" }
            });
        },
        submitInfo() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (this.readFileInfoList.length > 0) {
                        commonApi.fundFileLeaveTracesLog(
                            this,
                            this.readFileInfoList,
                            this.fund.fundcode
                        );
                    }
                    if (this.xjbFundFile.length > 0) {
                        commonApi.agreementLeaveTracesLog(
                            this,
                            {
                                eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/i",
                                eventname: `协议同意`
                            },
                            this.xjbFundFile
                        );
                    }
                    // 获取留痕申请编号
                    this.$util.writeFileInfo(
                        {
                            readFileInfoList: this.readFileInfoList,
                            fundcode: this.fund.fundcode,
                            tano: this.fund.tano
                        },
                        (res) => {
                            this.readappno = res;
                            if (this.readFileInfoList.length > 0 && this.readappno.length === 0) {
                                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
                            }
                            this.protocol = true;
                        }
                    );
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 双因素认证
        async smsCheck(val) {
            this.protocol = false;
            if (!val) return;
            let smsFlag = false; // 是否需要进行双因素认证
            if (
                this.$cache.getSysParam("10113004") &&
                this.$cache.getSysParam("10113004").indexOf("1") > -1 &&
                this.$cache.getSysParam("10113005") &&
                Number(this.$cache.getSysParam("10113005")) <= Number(this.fundInfo.amount)
            ) {
                smsFlag = true;
            }
            if (smsFlag) {
                const pwdRes = await userApi.combPasswordCheck({
                    tradepassword: this.$util.enc(this.fundInfo.pwd)
                });
                if (pwdRes.code != 0) {
                    return;
                }
                this.smsVisible = true;
            } else {
                this.generalBuy(val);
            }
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            if (this.readFileInfoList.length > 0 && this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            let data = {
                transactionaccountid: this.bankInfo.transactionaccountid,
                sharetype: this.bankInfo.sharetype,
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                paychannel: this.bankInfo.paycenterid,
                applicationamount: this.fundInfo.amount,
                readappno: this.readappno,
                buyflag: this.fund.riskmismatchflag == "1" ? "1" : "2",
                riskwarnflag: this.fund.riskwarnflag == "1" ? "1" : "2",
                highriskwarnflag: this.fund.highriskwarnflag == "1" ? "1" : "2"
            };
            this.randomToken = this.$util.generateRandomNumber();
            data.pagecallbackurl =
                window.location.origin +
                "" +
                "/sale-mid-ump/bank/redirect?token=" +
                this.randomToken;
            // 建行网联的回调地址配置在银行那边，需要单独处理
            if (this.bankInfo.paycenterid == "0105") {
                data.pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
            }
            // 开了高龄客户管理开关才用
            if (this.$util.buyVerificationOpen()) {
                this.$util.checkComplianceService(this.fund.fundcode).then((checkRes) => {
                    if (checkRes.dialogType) {
                        this.dialogButtonText = checkRes.dialogButtonText;
                        this.dialogType = checkRes.dialogType;
                        this.dialogContent = checkRes.dialogContent;
                        this.buyRiskdialogVisible = true;
                        this.paramsData = data;
                    } else {
                        // 下单
                        this.planOpen(data);
                    }
                });
            } else {
                // 下单
                this.planOpen(data);
            }
            // // 下单
            // this.planOpen(data);
        },
        smsClose() {
            this.smsVisible = false;
            this.$refs.protocol.protocol = [];
            this.$refs.protocol.index = 0;
        },
        // 处理弹窗确认事件（按钮点击）
        handleDialogConfirm() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.before_purchasing_verification,
                eventname: `高龄客户购买前校验确定按钮`,
                content: JSON.stringify(
                    Object.assign({
                        name: "高龄客户",
                        dialogContent: this.dialogContent,
                        dialogButtonText: this.dialogButtonText
                    })
                )
            });
            // 根据弹窗类型执行不同操作
            if (this.dialogType === "warn") {
                // 下单
                this.planOpen(this.paramsData);
            }
        },
        async planOpen(params) {
            this.isOpen = true;
            // 高龄客户风险警示标识 1-已警示
            if (this.dialogType == "warn") {
                params.oldercustriskflag = "1";
            }
            try {
                const res = await fundApi.combTransRealtaBuy(params);
                if (res.data) {
                    if (res.data.bankgateurl && res.data.method) {
                        const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                        let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                        if (pageParam) {
                            pageParam = JSON.parse(pageParam);
                        }
                        const reqMethod = res.data.method;
                        this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                        const params = {
                            token: this.randomToken,
                            appsheetserialno: res.data.appsheetserialno,
                            bankgateserialno: res.data.bankgateserialno,
                            portfolioappsheetno: res.data.appsheetserialno,
                            isrealta: 1,
                            paychannel: this.bankInfo.paycenterid
                        };
                        this.$util.confirmBankAuth(
                            this,
                            params,
                            "tradePayAuthentication",
                            (payStatus) => {
                                this.payStatus = payStatus;
                                this.resultDialog = true;
                            }
                        );
                    } else {
                        this.resultDialog = true;
                        this.appsheetserialno = res.data.appsheetserialno;
                        this.queryRealTransStatus();
                        const setTime = setInterval(() => {
                            this.countTime--;
                            // 如果倒计时未结束，查询出成功或者失败状态，直接结束倒计时
                            if (this.statusInfo != "0") {
                                this.finishStatus = true;
                                clearInterval(setTime);
                            } else if (this.countTime <= 0) {
                                // 如果倒计时结束，查询的结果还是查询中，则把状态改成充值结果未知
                                if (this.statusInfo == "0") {
                                    this.statusInfo = "2";
                                }
                                this.finishStatus = true;
                                clearInterval(setTime);
                            }
                        }, 1000);
                    }
                }
            } catch (e) {
                this.$log.error(e);
            } finally {
                this.isOpen = false;
            }
        },
        testTime() {
            this.timer = setTimeout(async () => {
                this.queryRealTransStatus();
            }, 1500);
        },
        // 查交易状态
        async queryRealTransStatus() {
            const checkeInfos = await fundApi.combQueryRealTransStatus({
                appsheetserialno: this.appsheetserialno
            });
            if (checkeInfos.data) {
                if (this.countTime > 0) {
                    if (checkeInfos.data.status == "07") {
                        this.statusInfo = "1";
                    } else if (checkeInfos.data.status == "04" || checkeInfos.data.status == "08") {
                        this.statusInfo = "2";
                    }
                }
                if (this.statusInfo == "1" || this.statusInfo == "2" || this.countTime <= 0) {
                    this.timer = null;
                } else {
                    this.testTime();
                }
            }
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        checkDebitdate(rule, value, callback) {
            if (value.trim() === "" && value.trim() !== "5") {
                callback(new Error("请选择扣款日期"));
            } else {
                callback();
            }
        },
        selectBank() {
            this.selectBankShow = true;
        },
        selectBankClose(value) {
            this.selectBankShow = false;
        },
        selectBankInfo(bankInfo) {
            this.bankInfo = bankInfo;
            this.fundInfo.pay =
                this.bankInfo.paycentername +
                "-" +
                this.$cache.getDict("110080", this.bankInfo.bankcode) +
                "(**" +
                this.bankInfo.depositcard.slice(-4) +
                ")";
            this.$set(
                this.limit,
                "min",
                this.bankInfo.netnominbuy ? this.bankInfo.netnominbuy : "0"
            );
            this.$set(this.limit, "max", this.bankInfo.netnomaxbuy);
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可充值" +
                this.$util.fmtNum(this.limit.max) +
                "元";
        },

        agrVisibleHide() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        // 查现金宝资产
        async getAssetsInfo() {
            const res = await fundApi.getHoldingAssets({});
            if (res.data && res.data.first) {
                this.fundInfo.availableMoney = res.data.first.xjbasset;
            }
        },
        resultDialogClose() {
            this.resultDialog = false;
            this.$router.push({ name: "moneybox" });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-in {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-top: 40px;
    margin-bottom: 20px;
    .payway-list {
        position: relative;
        .hot-area {
            width: 400px;
            height: 40px;
            // background-color: #1890ff;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99 !important;
            cursor: pointer;
        }
        .add-bank-btn {
            position: absolute;
            left: 410px;
            font-size: 14px;
            font-weight: normal;
            color: #1890ff;
            cursor: pointer;
        }
    }
    .available-money-box {
        display: flex;
        align-items: center;
        .available-money {
            font-size: 22px;
            font-weight: normal;
            color: var(--color-primary);
            vertical-align: top;
        }
    }
    .back-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #666666;
        border: none;
        cursor: pointer;
    }
    .confirm-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: 40px;
    }
    .active-btn {
        background: var(--color-primary);
        cursor: pointer;
    }
    .disable-btn {
        background: #f7b2b8;
    }
    .success-res {
        margin: 40px 0 30px;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .success-text {
            font-size: 26px;
            font-weight: 500;
            margin-top: 23.85px;
            color: #333333;
        }
    }
    .btn-box {
        text-align: center;
        padding-bottom: 56px;
        .btn-confirm {
            width: 180px;
            text-align: center;
            height: 42px;
            border-radius: 2px;
            color: #ffffff;
            border: none;
        }
    }
    .file-content {
        text-decoration: none;
        color: var(--color-primary);
        cursor: pointer;
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 80vh;
        min-height: 10vh;
        overflow: scroll;
    }
    .el-input,
    .el-select {
        width: 400px;
    }
    .el-input__inner {
        font-size: 22px !important;
        font-weight: normal;
        color: #333333;
    }
    .margin-l-10 {
        margin-left: 10px;
    }
    :deep(.el-form-item__label) {
        padding: 0;
        font-size: 14px;
        font-weight: normal;
        color: #333333;
    }
    :deep(.el-form-item__label:before) {
        display: none;
    }
}
</style>
